module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/protocolo-atendimento-tipo/protocolo-atendimento-tipo.component.css
// module id = ./src/app/protocolo-atendimento-tipo/protocolo-atendimento-tipo.component.css
// module chunks = main